import {FrameMetaKey, FrameMetaValue} from '@mintdata/mint-kit/api/values/frames/Frame';

export class FrameMeta
{
    private readonly _metadata:Map<FrameMetaKey, FrameMetaValue>;

    public constructor(metadata:Map<FrameMetaKey, FrameMetaValue> = null)
    {
        this._metadata = new Map<FrameMetaKey, FrameMetaValue>(metadata);
        Object.freeze(this._metadata);
    }

    public getKeys():Array<FrameMetaKey>
    {
        return Array.from(this._metadata.keys());
    }

    public getValue(key:FrameMetaKey):FrameMetaValue
    {
        return this._metadata.get(key);
    }

    public clone():FrameMeta
    {
        return new FrameMeta(this._metadata);
    }
}
